/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PractitionerStrictHttpResponse } from '../../practitioner-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PractitionerRoleModel } from '../../models/practitioner-role-model';

export interface ConsumerPersonIdSaveRolesPost$Params {
  personId: string;
      body?: PractitionerRoleModel
}

export function consumerPersonIdSaveRolesPost(http: HttpClient, rootUrl: string, params: ConsumerPersonIdSaveRolesPost$Params, context?: HttpContext): Observable<PractitionerStrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, consumerPersonIdSaveRolesPost.PATH, 'post');
  if (params) {
    rb.path('personId', params.personId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as PractitionerStrictHttpResponse<string>;
    })
  );
}

consumerPersonIdSaveRolesPost.PATH = '/Consumer/{personId}/SaveRoles';
